import type { ReactNode } from "react"
import { Card } from "@/components/ui/Card"
import { cn } from "@/lib/utils"

interface Props {
  label: string
  value: ReactNode
  /** Colors the value when the number itself is the warning. */
  tone?: "default" | "warning"
  children?: ReactNode
}

export default function StatTile({ label, value, tone = "default", children }: Props) {
  return (
    <Card className="flex flex-col gap-1 px-5 py-4">
      <div className="text-xs font-medium">{label}</div>
      <div className={cn("text-2xl font-semibold tabular-nums tracking-tight", tone === "warning" && "text-warning")}>
        {value}
      </div>
      {children && <div className="text-xs">{children}</div>}
    </Card>
  )
}
